import React from 'react';
import {
    Spinner
} from '@shopify/polaris';
import CustomerOperationsCreateStep from './CustomerOperationsCreateStep';
import { apiFetch as fetch } from '../../../../common/Helpers';

class CustomerOperationPage extends React.Component {

    state = {
        loadedTags: false,
        loadedStorInfo: false,
        loadedOperation: false,
        loadingPreview: false,
        tags: [],
        operation: null,
        preview: null,
        storeInfo: null,
        execution: {
            executionChoice: "now",
            executionTime: (new Date()).toISOString().substring(0, 16),
            executionFrequency: "EveryDay"
        },
        editId: null,
    };

    constructor(props) {
        super(props)

        const { params } = this.props.match;

        if (params.id) {
            this.state.editId = params.id
        }
    }

    render() {

        let createAction = "Preview Operation";
        let createActionHandler = this.handlePreview;
        let loading = !this.state.loadedStorInfo || !this.state.loadedTags;

        if (this.state.editId != null) {
            loading = loading || !this.state.loadedOperation;
        }

        return (
            <React.Fragment>
                {loading && <Spinner accessibilityLabel="Loading" size="large" color="teal" />}
                {(!loading) && <CustomerOperationsCreateStep
                    tags={this.state.tags}
                    operation={this.state.operation}
                    execution={this.state.execution}
                    preview={this.state.preview}
                    loadingPreview={this.state.loadingPreview}
                    actionText={createAction}
                    onAction={createActionHandler}
                    onCancel={this.handleCancel}
                    onPreview={this.handleOnPreview}
                    onClearPreview={this.handleClearPreview}
                    onSubmit={this.handleSubmit}
                    onSave={this.handleSave} />}
            </React.Fragment>);
    }

    handleClearPreview = () => {
        this.setState({
            loadingPreview: false,
            preview: null
        });
    }

    handleOnPreview = (actions, filters, filtersLogicalOperator) => {

        this.setState({
            loadingPreview: true
        });

        const mappedFilters = filters.map((_) => _.body);
        const filter = {
            "filterType": "composite",
            "logicalOperator": filtersLogicalOperator,
            "children": mappedFilters
        };
        fetch(`api/operations/customer/tag/preview`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                actions: actions,
                filter: filter,
            })
        })
            .then(response => response.json())
            .then(data => this.setState({
                loadingPreview: false,
                preview: data
            }));
    }

    handleSubmit = (operation) => {

        const mappedFilters = operation.filters.map((_) => _.body);
        const filter = {
            "filterType": "composite",
            "logicalOperator": operation.filtersLogicalOperator,
            "children": mappedFilters
        };

        fetch(`api/operations/customer/tag`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                actions: operation.actions,
                filter: filter,
                execution: operation.execution
            })
        }).then(_ => {
            this.props.history.push("/operations");
        });
    }

    handleSave = (operation) => {
        
        const mappedFilters = operation.filters.map((_) => _.body);
        const filter = {
            "filterType": "composite",
            "logicalOperator": operation.filtersLogicalOperator,
            "children": mappedFilters
        };

        fetch(`api/operations/customer/tag/${this.state.editId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                actions: operation.actions,
                filter: filter,
                execution: operation.execution
            })
        }).then(_ => {
            this.props.history.push(`/operations/customer/${this.state.editId}`);
        });
    }

    getStoreInfo = () => {
        fetch(`api/storeConnections/info`, {
            method: 'GET',
        }).then(response => response.json())
            .then((data) => {
                this.setState({
                    storeInfo: data,
                    loadedStorInfo: true
                })
            });
    }

    handleCancel = () => {
        this.props.history.push(`/operations/customer/${this.state.editId}`);
    }

    componentDidMount() {
        fetch(`api/customers/tags`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                tags: data,
                loadedTags: true
            }));

        this.getStoreInfo();

        if (this.state.editId != null) {
            fetch(`api/operations/customer/tag/${this.state.editId}`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(data => {
                    let filters = [];
                    let filtersLogicalOperator = "And";

                    if (data.filter != null) {
                        filters = data.filter.children.map((_, index) => { return { ..._, id: index } });
                        filtersLogicalOperator = data.filter.logicalOperator;
                    }

                    let actions = data.actions.map((_, index) => { return { ..._, id: index } });
                    let execution = data.execution;
                    if (execution.executionTime != null) {
                        execution.executionTime = execution.executionTime.substring(0, 16);
                    }

                    this.setState({
                        operation: {
                            filters: filters,
                            filtersLogicalOperator: filtersLogicalOperator,
                            actions: actions,
                            description: data.description,
                            id: data.id
                        },
                        execution: execution,
                        loadedOperation: true
                    })
                });
        }
    }
}

CustomerOperationPage.defaultProps = {
    tags: [],
    preview: null,
    title: "Create Operation",
}

export default CustomerOperationPage;